import CustomPlatform from "../assets/Icons/CustomPlatform";
import KickIcon from "../assets/Icons/KickIcon";
import TwitchIcon from "../assets/Icons/Twitch";
import YoutubeIcon from "../assets/Icons/YoutubeIcon";

export const MAX_FILE_SIZE_GB = 15;
export const COLUMN_1 = "column-1";
export const COLUMN_2 = "column-2";

export const IMAGE_PLACEHOLDER_URL = "/images/image_placeholder.jpeg";
export const GIF_PLACEHOLDER_URL = "/images/image_placeholder.jpeg";
export const VIDEO_PLACEHOLDER_URL = "/video_placeholder.mp4";

export const STREAM_TYPE_PLAYLIST = "playlist";
export const STREAM_TYPE_VIDEO = "video";

export const STREAM_RADIO_EXAMPLE_STREAM_ID = "XAQsEKhNtNA";

export const DATE_FORMAT_FRONTEND = "MM/dd/yyyy";
export const DATE_TIME_FORMAT_FRONTNED = `${DATE_FORMAT_FRONTEND} hh:mm a`;

// Brand URL constants — derived from environment variables with sensible defaults
export const APP_URL = import.meta.env.VITE_APP_URL || "https://my.streaminal.com";
export const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL || "https://www.streaminal.com";
export const STATIC_ASSETS_URL = import.meta.env.VITE_STATIC_ASSETS_URL || "https://s3-static.streaminal.net";
export const S3_URL = import.meta.env.VITE_S3_URL || "https://s3.streaminal.com";
export const OPENREPLAY_INGEST = import.meta.env.VITE_OPENREPLAY_INGEST || "https://or.streaminal.com/ingest";
export const OPENREPLAY_KEY = import.meta.env.VITE_OPENREPLAY_KEY || "";
export const FEEDBQ_ORG_ID = import.meta.env.VITE_FEEDBQ_ORG_ID || "";
export const GRAFANA_URL = import.meta.env.VITE_GRAFANA_URL || "https://gfn.streaminal.com";
export const COMPANY_EMAIL = import.meta.env.VITE_COMPANY_EMAIL || "info@streaminal.com";
export const ENABLE_PRO_PLAN = import.meta.env.VITE_ENABLE_PRO_PLAN === "true";


/** A single-color platform mark. It paints with currentColor, so it follows the surrounding text color. */
export type PlatformIcon = React.ComponentType<{ width?: string; height?: string }>;

export const DEFAULT_PLATFORMS: {
  id: number;
  name: string;
  label: string;
  value: string;
  icon: PlatformIcon;
  regex?: RegExp;
}[] = [
  {
    id: 2,
    name: "youtube",
    label: "Youtube",
    value: "youtube",
    icon: YoutubeIcon,
    regex:
      /^[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}$/i,
  },
  {
    id: 3,
    name: "twitch",
    label: "Twitch",
    value: "twitch",
    icon: TwitchIcon,
    regex: /^live\_(.)+$/i,
  },
  {
    id: 4,
    name: "kick",
    label: "Kick",
    value: "kick",
    icon: KickIcon,
  },
  {
    id: 5,
    name: "custom",
    label: "Custom",
    value: "custom",
    icon: CustomPlatform,
  },
];

export const TUTORIAL_VIDEO_ID = "-np8p8n-kN0";
export const MULTI_ITEM_TUTORIAL_VIDEO_ID = "V030e39xDvs";
export const SCHEDULE_STREAM_TUTORIAL_VIDEO_ID = "7uCCPHVZ09o";

export const MAX_FILE_SIZE_BYTES = 15 * 1024 * 1024 * 1024;
/** Must equal the API's Drive import limit (visualMedia.service.ts importGDriveFile). */
export const MAX_IMPORT_FILE_SIZE_BYTES = 10 * 1024 * 1024 * 1024;
export const ENABLE_PIXELS = true;

export const TOKEN_KEY = "token"
export const USER_KEY = "user"

export const MULTI_LIVE_STREAM_ITEM_WORKER_VERSION = 2;

export const SHOW_ITEM_PREFIX = "show_item_" as const;
export const JINGLE_ITEM_PREFIX = "jingle_item_" as const;
export const SECONDARY_ITEM_PREFIX = "secondary_item_" as const;

export const WATERMARK_TEXT = "Powered by Streaminal.com";
export const isWatermarkOverlay = (overlay: { text?: string | null }) =>
  overlay.text === WATERMARK_TEXT;
// export const VERTICAL_VIDEO_WIDTH = 360;
export const VERTICAL_VIDEO_WIDTH = 230;
export const VERTICAL_VIDEO_HEIGHT = (VERTICAL_VIDEO_WIDTH * 16) / 9;
export const VIDEO_BITRATE_OPTIONS = [
  3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 7000, 8000, 9000, 10000,
  12000, 16000, 20000,
];
export const DEFAULT_VIDEO_BITRATE = 7000;
/** PLAN_DEFAULTS.r2160p.videoBitrate in api/src/billing/plans.ts. */
export const DEFAULT_4K_VIDEO_BITRATE = 16000;

export const AUDIO_BITRATE_OPTIONS = [128, 256, 320];
export const DEFAULT_AUDIO_BITRATE = 320;

export const FPS_OPTIONS = [25, 30];
export const DEFAULT_FPS = 30;

import { LiveStreamResolutionEnum } from "../types/models";

export function resolutionLabel(resolution: LiveStreamResolutionEnum): string {
  return resolution === LiveStreamResolutionEnum.r2160p ? "4K (2160p)" : "1080p";
}
